export const handleize = (str): string => {
  if (typeof str !== 'undefined') {
    str = str.toLowerCase();
    const toReplace = ['"', "'", '\\', '(', ')', '[', ']'];
    for (let i = 0; i < toReplace.length; i += 1) {
      str = str.replace(toReplace[i], '');
    }
    str = str.replace(/\W+/g, '-');
    if (str.charAt(str.length - 1) == '-') {
      str = str.replace(/-+\z/, '');
    }
    if (str.charAt(0) == '-') {
      str = str.replace(/\A-+/, '');
    }
    return str;
  }
};
